import { shallowEqual } from 'react-redux';

import { useAppSelector, AppState } from '@redux/store';

export const useShowsIds = () =>
  useAppSelector(
    ({ search }: AppState) => search.shows?.ids || [],
    shallowEqual,
  );

export const useShowsMayloadMore = () =>
  useAppSelector(({ search }: AppState) => search.shows?.mayLoadMore || false);

export const useChannelsIds = () =>
  useAppSelector(
    ({ search }: AppState) => search.channels?.ids || [],
    shallowEqual,
  );

export const useChannelsMayloadMore = () =>
  useAppSelector(
    ({ search }: AppState) => search.channels?.mayLoadMore || false,
  );
